import { getEnvVariable } from "@/lib/utils/env";;
import { getStoreOverride } from "@/lib/dev/store-override.utils";

const isLocalhost = () => {
    return window.location.hostname.includes('localhost') || window.location.hostname.includes('127.0.0.1');
}

export const getStoreDomain = () => {
    const storeOverride = getStoreOverride();
    if (storeOverride) {
        return storeOverride;
    }
    if (isLocalhost() && getEnvVariable('NEXT_PUBLIC_STORE_DOMAIN')) {
        return getEnvVariable('NEXT_PUBLIC_STORE_DOMAIN')
    }
    if (typeof window !== 'undefined') {
        return window.location.hostname;
    }
    return '';
}